@if (error() && message(); as message) {
  <div class="alert alert-warning {{ andClass() }}">
    <h4>
      <i class="fa fa-info-circle me-1"></i>
      {{ message.title | translate }}
    </h4>
    <p>
      {{ message.text | translate }}
      <br />
      {{ 'common.errors.try_again_later' | translate }}
    </p>
    @if (originalMessage(); as originalMessage) {
      <hr />
      <p class="pb-0 mb-0 small" style="word-break: break-all">
        {{ originalMessage }}
      </p>
    }
  </div>
}
